import { ref, computed, onMounted, onBeforeUnmount } from "vue";
const consentGiven = ref([]);
const isSocialConsentGiven = computed(() => consentGiven.value.includes("social"));
const consentChanged = () => {
  var _a, _b, _c;
  consentGiven.value = ((_c = (_b = (_a = window == null ? void 0 : window.utag) == null ? void 0 : _a.gdpr) == null ? void 0 : _b.getSelectedCategories) == null ? void 0 : _c.call(_b)) || [];
};
const registerConsent = () => {
  onMounted(() => {
    window.addEventListener("consentChanged", consentChanged);
    window.addEventListener("load", consentChanged);
    consentChanged();
  });
  onBeforeUnmount(() => {
    window.removeEventListener("consentChanged", consentChanged);
    window.removeEventListener("load", consentChanged);
  });
};
export {
  consentChanged,
  consentGiven,
  isSocialConsentGiven,
  registerConsent
};
